export const ROLES = {
  ADMIN: "administrator",
  USER: "user",
};
